import store from '../store'

export default async (to, from, next) => {
  await store.dispatch('ui/ActionSetLoading', true)

  if (to.name != 'Login' && !store.getters['auth/GET_token']) {
    try {
      await store.dispatch('auth/ActionCheckToken')
      await Promise.all([
        store.dispatch('employees/ActionSetBirthdays'),
        store.dispatch('employees/ActionSetEmployeeScales'),
        store.dispatch('utils/ActionSetUtils'),
        store.dispatch('employees/ActionSetEmployees'),
        store.dispatch('employees/ActionSetEmployeeSwaps'),
        store.dispatch('employees/ActionSetIncomeTaxes'),
        store.dispatch('scales/ActionSetReceivedSwaps'),
      ])
      document.title = `${to.name} :: IPH - Sistemas`
      next({ name: to.name })
    } catch (error) {
      next({ name: 'Login' })
      document.title = `${to.meta.name} :: IPH - Sistemas`
    }
  } else {
    if (to.name == 'Login' && store.getters['auth/GET_token']) {
      next({ name: 'home' })
      document.title = `${to.meta.name} :: IPH - Sistemas`
    } else if (to.name == 'Login' && !store.getters['auth/GET_token']) {
      next()
    } else {
      document.title = `${to.meta.name} :: IPH - Sistemas`
      store.dispatch('auth/ActionProfile')
      next()
    }
  }
  await store.dispatch('ui/ActionSetLoading', false)
}
